class CartAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    ['onDocumentClick', 'onClickButton'].forEach((eventName) => {
      this[eventName] = this[eventName].bind(this);
    });

    this.buttonEl = this.querySelector('[data-cart-accordion-button]');

    document.addEventListener('click', this.onDocumentClick);

    if (this.buttonEl) {
      this.buttonEl.addEventListener('click', this.onClickButton);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);

    if (this.buttonEl) {
      this.buttonEl.removeEventListener('click', this.onClickButton);
    }
  }

  onClickButton() {
    this.classList.toggle('is-open');
  }

  onDocumentClick(event) {
    var isClickInside = this.contains(event.target);

    if (!isClickInside) {
      this.classList.remove('is-open');
    }
  }
}

customElements.define('vbb-cart-accordion', CartAccordion);
